var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveLogD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 400,
    viewBox: "0 0 1280 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1095.8 43.2984C1111.23 49.6686 1125.81 57.3128 1139.95 66.2311C1234.68 124.837 1294.69 239.075 1277.12 348.218C1259.12 459.059 1140.81 616.614 1023.79 639.547C985.635 647.191 946.628 636.574 909.335 625.108C846.752 605.997 788.026 574.996 726.3 557.159C702.296 550.365 676.148 548.666 653 558.009C612.707 574.146 602.848 608.97 585.702 644.218C566.412 684.138 533.835 717.688 494.399 738.497C413.383 780.965 308.792 761.005 233.777 715.14C122.328 647.191 82.4628 513.417 119.327 391.959C128.757 360.533 143.76 329.532 168.622 307.448C211.059 269.227 274.928 262.432 330.653 276.447C369.232 286.214 404.381 304.9 437.816 325.285C465.25 342.272 490.541 365.629 524.404 365.629C592.989 366.054 613.993 278.57 635.854 229.732C664.574 165.181 713.012 108.699 773.023 70.9025C869.899 9.32416 990.351 -1.2928 1095.8 43.2984Z",
    fill: "url(#paint0_linear_44_688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.84 43.5566C1111.26 49.9254 1125.83 57.5681 1139.97 66.4845C1234.65 125.078 1294.64 239.293 1277.07 348.414C1259.08 459.232 1140.82 616.756 1023.86 639.684C985.723 647.326 946.734 636.712 909.458 625.248C846.904 606.141 788.206 575.146 726.509 557.313C702.515 550.519 676.38 548.821 653.243 558.162C612.969 574.297 603.114 609.113 585.976 644.354C566.696 684.266 534.133 717.809 494.716 738.614C413.738 781.073 309.195 761.117 234.216 715.261C122.818 647.326 82.972 513.58 119.819 392.147C129.245 360.727 144.241 329.732 169.091 307.653C211.508 269.439 275.347 262.646 331.046 276.658C369.607 286.423 404.74 305.105 438.16 325.486C465.581 342.469 490.859 365.822 524.707 365.822C593.26 366.246 614.254 278.781 636.105 229.952C664.812 165.414 713.227 108.944 773.21 71.155C870.041 9.58919 990.436 -1.02561 1095.84 43.5566Z",
    fill: "url(#paint1_radial_44_688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3201 915.588C-107.431 770.773 5.73328 451.839 192.198 354.163C262.068 317.641 343.512 303.626 421.956 313.819C492.684 323.161 580.986 346.943 653.429 319.764C708.296 298.955 733.587 247.569 762.307 200.854C842.036 70.9025 1043.07 46.6958 1142.95 169.853C1179.82 215.293 1194.82 278.57 1176.81 334.203C1134.38 463.305 992.065 408.097 911.478 477.32C879.329 504.924 870.756 560.132 851.895 597.079C832.606 634.875 809.03 670.973 783.739 705.372C730.586 777.992 665.86 844.242 591.274 895.628C442.531 998.4 256.496 1028.98 99.1798 924.931C94.8932 921.958 90.6067 918.985 86.3201 915.588Z",
    fill: "url(#paint2_linear_44_688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3201 915.588C-107.431 770.773 5.73328 451.839 192.198 354.163C262.068 317.641 343.512 303.626 421.956 313.819C492.684 323.161 580.986 346.943 653.429 319.764C708.296 298.955 733.587 247.569 762.307 200.854C842.036 70.9025 1043.07 46.6958 1142.95 169.853C1179.82 215.293 1194.82 278.57 1176.81 334.203C1134.38 463.305 992.065 408.097 911.478 477.32C879.329 504.924 870.756 560.132 851.895 597.079C832.606 634.875 809.03 670.973 783.739 705.372C730.586 777.992 665.86 844.242 591.274 895.628C442.531 998.4 256.496 1028.98 99.1798 924.931C94.8932 921.958 90.6067 918.985 86.3201 915.588Z",
    fill: "url(#paint3_radial_44_688)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44_688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.3345 855.097C-200.645 722.073 -97.667 429.109 72.0118 339.386C135.593 305.837 209.705 292.964 281.087 302.326C345.448 310.909 425.802 332.754 491.723 307.788C541.652 288.673 564.666 241.471 590.8 198.56C663.352 79.1899 846.293 56.9542 937.179 170.083C970.724 211.824 984.377 269.948 967.994 321.051C929.377 439.641 799.875 388.928 726.543 452.515C697.288 477.871 689.487 528.584 672.324 562.523C654.771 597.241 633.317 630.4 610.303 661.998C561.935 728.705 503.035 789.56 435.164 836.762C299.811 931.166 130.522 959.253 -12.6325 863.679C-16.5331 860.948 -20.4339 858.218 -24.3345 855.097Z",
    fill: "url(#paint4_linear_44_688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.3345 855.097C-200.645 722.073 -97.667 429.109 72.0118 339.386C135.593 305.837 209.705 292.964 281.087 302.326C345.448 310.909 425.802 332.754 491.723 307.788C541.652 288.673 564.666 241.471 590.8 198.56C663.352 79.1899 846.293 56.9542 937.179 170.083C970.724 211.824 984.377 269.948 967.994 321.051C929.377 439.641 799.875 388.928 726.543 452.515C697.288 477.871 689.487 528.584 672.324 562.523C654.771 597.241 633.317 630.4 610.303 661.998C561.935 728.705 503.035 789.56 435.164 836.762C299.811 931.166 130.522 959.253 -12.6325 863.679C-16.5331 860.948 -20.4339 858.218 -24.3345 855.097Z",
    fill: "url(#paint5_radial_44_688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 152C48.3416 152 32 135.658 32 115.5C32 95.3416 48.3416 79 68.5 79C88.6584 79 105 95.3416 105 115.5C105 135.658 88.6584 152 68.5 152Z",
    fill: "url(#paint6_linear_44_688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5 269C272.103 269 258 254.897 258 237.5C258 220.103 272.103 206 289.5 206C306.897 206 321 220.103 321 237.5C321 254.897 306.897 269 289.5 269Z",
    fill: "url(#paint7_linear_44_688)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_688",
    x1: 40.3663,
    y1: 776.404,
    x2: 1657.4,
    y2: -115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_44_688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(698.531 -99.209) rotate(79.6257) scale(1313.6 1235.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_688",
    x1: 1161.45,
    y1: -450.926,
    x2: 133.503,
    y2: 1208.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_44_688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(857.512 161.069) rotate(-122.724) scale(1401.84 2365.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_44_688",
    x1: 954.014,
    y1: -400.149,
    x2: 5.83749,
    y2: 1116.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_44_688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(677.435 162.015) rotate(-122.48) scale(1284.19 2158.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_44_688",
    x1: -16.7676,
    y1: 175.573,
    x2: 157.273,
    y2: 52.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703531,
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_44_688",
    x1: 215.913,
    y1: 289.344,
    x2: 366.113,
    y2: 183.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5183,
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 393,
    fill: "white",
    transform: "translate(769 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1178,
    height: 538,
    fill: "white",
    transform: "matrix(-1 0 0 1 1062 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveLogD);
export default __webpack_public_path__ + "static/media/waveLog_d.fcff7a885f6135c5fa4b16e3e3447778.svg";
export { ForwardRef as ReactComponent };